import { render, staticRenderFns } from "./StoriesStats.vue?vue&type=template&id=91205940&scoped=true&"
import script from "./StoriesStats.vue?vue&type=script&lang=js&"
export * from "./StoriesStats.vue?vue&type=script&lang=js&"
import style0 from "./StoriesStats.vue?vue&type=style&index=0&id=91205940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91205940",
  null
  
)

component.options.__file = "StoriesStats.vue"
export default component.exports